import * as React from 'react'
import { Text } from '$views/components/Text'
import { Block } from '$views/components/Layout/Block'
import locationIcon from '$icons/location.svg'
import { Icon } from '$views/components/Icon'
import { StyledInput, StyledBlock, StyledItem } from './Autocomplete.styles'

interface Props {
  getInputProps: any
  suggestions: any
  getSuggestionItemProps: any
  loading: any
}

export const AutocompleteView: React.SFC<Props> = ({ getInputProps, suggestions, getSuggestionItemProps }) => {
  return (
    <Block marginTop="mini">
      <StyledInput
        primary="true"
        {...getInputProps({
          placeholder: 'Introduce una dirección (calle y nº...)',
          className: 'location-search-input',
        })}
      />
      <StyledBlock>
        {suggestions.map(suggestion => {
          const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
          const style = suggestion.active
            ? { backgroundColor: '#f8f8f8', cursor: 'pointer' }
            : { backgroundColor: '#ffffff', cursor: 'pointer' }
          return (
            <StyledItem
              key={suggestion.placeId}
              {...getSuggestionItemProps(suggestion, {
                className,
                style,
              })}
            >
              <Icon content={locationIcon} size="s" color="grey" />
              <Text as="span">{suggestion.description}</Text>
            </StyledItem>
          )
        })}
      </StyledBlock>
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Forms/LocationInput/Autocomplete/Autocomplete.view.tsx